import React from 'react';
import { Heart, Mail, ExternalLink, Linkedin, Twitter, GraduationCap } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_61ca5ff4-bcc2-4cdc-8453-7407936ace18/artifacts/6nklllpo_TaxSetu_Only_Logo_Design_Infinite-removebg-preview.png";

const Footer = () => {
  return (
    <footer className="bg-[#080C16] text-white mt-auto w-full border-t border-white/5">
      <div className="w-full px-6 lg:px-16 xl:px-24 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src={LOGO_URL} 
                alt="PractiQ Logo" 
                className="w-10 h-10 object-contain"
              />
              <div>
                <h3 className="text-lg font-semibold">
                  <span className="bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">PractiQ</span>
                </h3>
                <p className="text-xs text-teal-400">EdTech AI Simulation Platform</p>
              </div>
            </div>
            <p className="text-gray-500 text-base leading-relaxed mb-4 max-w-md">
              India&apos;s first tax filing simulator. An <span className="text-teal-400 font-medium">educational technology platform</span> helping CA students and professionals 
              master tax compliance through hands-on practice.
            </p>
            <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-gradient-to-r from-teal-500/10 to-cyan-500/10 border border-teal-500/20 mb-4 w-fit">
              <GraduationCap className="w-4 h-4 text-teal-400" />
              <span className="text-sm text-teal-300">EdTech Learning Platform</span>
            </div>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 transition-all">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 transition-all">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Modules</h4>
            <ul className="space-y-3 text-base">
              <li>
                <a href="/gst/registration" className="text-gray-500 hover:text-teal-400 transition-colors flex items-center gap-2">
                  <ExternalLink className="w-4 h-4" />
                  GST Registration
                </a>
              </li>
              <li>
                <a href="/gst/gstr1" className="text-gray-500 hover:text-teal-400 transition-colors flex items-center gap-2">
                  <ExternalLink className="w-4 h-4" />
                  GSTR-1 Filing
                </a>
              </li>
              <li>
                <a href="/gst/gstr3b" className="text-gray-500 hover:text-teal-400 transition-colors flex items-center gap-2">
                  <ExternalLink className="w-4 h-4" />
                  GSTR-3B Filing
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3 text-base">
              <li>
                <a href="mailto:support@taxsetu.ai" className="flex items-center gap-2 text-gray-500 hover:text-teal-400 transition-colors">
                  <Mail className="w-5 h-5 text-teal-500" />
                  support@taxsetu.ai
                </a>
              </li>
            </ul>
            
            {/* Policy Links */}
            <div className="mt-6 pt-4 border-t border-white/5">
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="/privacy-policy" className="text-gray-500 hover:text-teal-400 transition-colors">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/terms" className="text-gray-500 hover:text-teal-400 transition-colors">
                    Terms & Conditions
                  </a>
                </li>
                <li>
                  <a href="/refund-policy" className="text-gray-500 hover:text-teal-400 transition-colors">
                    Refund Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-center md:text-left">
              <p className="text-sm text-gray-400 mb-1">
                <span className="text-white font-medium">PractiQ LLP</span> — EdTech AI Simulation Platform
              </p>
              <p className="text-xs text-gray-600">
                © 2025-26 PractiQ LLP. All rights reserved. | <span className="text-amber-500">Educational Platform</span> | Not a Government Website
              </p>
              <p className="text-[11px] text-gray-700 mt-1">
                Registered Office: A-50, Street-3, New Modern Shahdara, Delhi — 110032 · RoC Delhi II
              </p>
            </div>
            <div className="flex items-center gap-2 bg-gradient-to-r from-amber-900/20 to-amber-900/20 px-5 py-2.5 rounded-full border border-amber-500/20">
              <Heart className="w-4 h-4 text-rose-500 fill-rose-500" />
              <span className="text-sm text-gray-300">Conceptualised & Designed by</span>
              <span className="text-sm font-semibold text-amber-400 italic">CA Shivangi Mittal</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
